import React from 'react';
import { Navigate } from 'react-router-dom';

import { RECURRING_RECEIVABLES_ROUTE } from 'constants/index';

function Success() {
  return <Navigate to={RECURRING_RECEIVABLES_ROUTE} />;
}

export { Success };
